import { regionsFetched, regionsFetching, regionsError } from '../actions/regions.types';
import { keyBy } from 'lodash';

export default (state = {}, { type, payload } = {}) => {
  switch (type) {
  case regionsFetching:
    return { fetching: true, fetched: false };
  case regionsFetched:
    return { fetching: false, fetched: true, data: keyBy(payload, 'id') };
  case regionsError:
    return { fetching: false, fetched: false, error: payload };
  default:
    return state;
  }
};

